import script from "./ActivityLogLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityLogLoader.vue?vue&type=script&setup=true&lang=js"

import "./ActivityLogLoader.vue?vue&type=style&index=0&id=5adb7b4a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adb7b4a"]])

export default __exports__